exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c2c-pdf-page{position:relative;flex:none;margin:16px auto;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,.2)}.c2c-pdf-page .annotationLayer{position:absolute;inset:0}.c2c-pdf-page .annotationLayer input,.c2c-pdf-page .annotationLayer select,.c2c-pdf-page .annotationLayer textarea{box-sizing:border-box}", ""]);

// exports
